import { useEffect, useRef } from "react"
import {
  Question,
  RadioQuestion,
  SliderQuestion,
  TextQuestion
} from "../../types/questionTypes"
import { Data } from "../../types/dataTypes"
import { TextareaInput } from "./TextareaInput"
import { RadioButtonGroup } from "./RadioButtonGroup"
import { SliderInput } from "./SliderInput"
import { TextInput } from "./TextInput"
import { CheckboxGroup } from "./CheckboxGroup"

export interface SurveyStepProps {
  data: Data
  question: Question
  updateFields: (newData: Data) => void
}

export default function SurveyStep({
  data,
  question,
  updateFields
}: SurveyStepProps): JSX.Element {
  const scrollRef = useRef<null | HTMLDivElement>(null)

  useEffect(() => {
    scrollRef?.current?.parentElement?.parentElement?.scroll({
      top: 0,
      behavior: "smooth"
    })
  }, [])

  const { fieldType } = question

  const renderQuestion = () => {
    switch (fieldType) {
      case "radio":
        return (
          <RadioButtonGroup
            data={data}
            question={question as RadioQuestion}
            updateFields={updateFields}
            className="mb-8"
          />
        )
      case "checkbox":
        return (
          <CheckboxGroup
            data={data}
            question={question as RadioQuestion}
            updateFields={updateFields}
            className="mb-8"
          />
        )
      case "text":
        return (
          <TextInput
            data={data}
            question={question as RadioQuestion}
            updateFields={updateFields}
            className="mb-8"
          />
        )
      case "notes":
        return (
          <TextareaInput
            data={data}
            question={question as TextQuestion}
            updateFields={updateFields}
            className="mb-6"
          />
        )
      case "slider":
        return (
          <SliderInput
            data={data}
            question={question as SliderQuestion}
            updateFields={updateFields}
          />
        )
      case "descriptive":
        return (
          <p
            className="mb-9 lg:p-8 lg:mb-6"
            dangerouslySetInnerHTML={{ __html: question.fieldLabel }}
          />
        )
      default:
        return <div></div>
    }
  }

  return (
    <>
      <div ref={scrollRef} />
      {renderQuestion()}
    </>
  )
}
